// pages/emailid-update-user/index.js

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateEmail } from "./actions";
import UpdateUserEmail from "./component";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateEmailConnect: updateEmail,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserEmail);
